/** Official store listings (Norwegian storefronts) */
export const APP_STORE_URL =
  'https://apps.apple.com/no/app/l%C3%B8peglad/id6741588236?l=nb';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.app.lopeglad&hl=no';

/**
 * Detect mobile OS for store fallback after custom URL scheme fails.
 * @returns {'ios' | 'android' | 'other'}
 */
export function getMobileStoreKind() {
  const ua = navigator.userAgent || navigator.vendor || '';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

/**
 * URL to open when the app is not installed (after deeplink attempt).
 */
export function getStoreFallbackUrl() {
  const kind = getMobileStoreKind();
  if (kind === 'ios') return APP_STORE_URL;
  if (kind === 'android') return PLAY_STORE_URL;
  return null;
}

/**
 * Try custom scheme, then send user to the right store(s) if the app did not open.
 * @param {string} deeplink - e.g. 'lopeglad://' or 'lopeglad://weekly-exercise/123'
 * @param {{ desktopSameTabPlayFirst?: boolean }} [options]
 */
export function tryOpenAppThenStore(deeplink, options = {}) {
  const { desktopSameTabPlayFirst = true } = options;
  const fallbackDelayMs = 1200;
  let appSwitchDetected = false;
  let fallbackTimer = null;

  const cleanup = () => {
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
    window.removeEventListener('pagehide', handleAppSwitch, true);
    window.removeEventListener('blur', handleAppSwitch, true);
    document.removeEventListener('visibilitychange', handleVisibilityChange, true);
  };

  const handleAppSwitch = () => {
    appSwitchDetected = true;
    cleanup();
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      handleAppSwitch();
    }
  };

  window.addEventListener('pagehide', handleAppSwitch, true);
  window.addEventListener('blur', handleAppSwitch, true);
  document.addEventListener('visibilitychange', handleVisibilityChange, true);

  window.location.href = deeplink;

  fallbackTimer = setTimeout(() => {
    // If page was backgrounded/hidden, assume app opened successfully.
    if (appSwitchDetected || document.visibilityState === 'hidden') {
      cleanup();
      return;
    }

    const fallback = getStoreFallbackUrl();
    if (fallback) {
      cleanup();
      window.location.href = fallback;
      return;
    }

    // Desktop / unknown: offer both stores (avoid popup blockers by using same-tab + user can open App Store from site)
    if (desktopSameTabPlayFirst) {
      cleanup();
      window.location.href = PLAY_STORE_URL;
      window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
    } else {
      cleanup();
      window.location.href = APP_STORE_URL;
      window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    }
  }, fallbackDelayMs);
}
